import clsx from 'clsx'
import React, {useContext} from 'react'
import ClearableSelect from 'components/clearable-select'
import MenuItem from '@mui/material/MenuItem'

import {TeacherContext} from 'teacher/context'

export default function UnitFilter (props) {

  const {classes, onChange} = props
  const context = useContext(TeacherContext)
  const {query, translate} = context
  const units = context.query.course && context.units
    ? context.units
    : []

  return (
    <ClearableSelect
      id="question-bank-unit-filter"
      className={clsx(classes.select, "unit")}
      value={query.unit || ""}
      onChange={onChange}
      caption={translate('unitName-header')}
    >
      {units.map((unit, key) => {
        const name = `${(key + 1).toString().padStart(2, '0')} - ${unit.name}`
        return (<MenuItem value={unit.id} key={key}>{name}</MenuItem>)
      })}
    </ClearableSelect>
  )
}
